export const actionTypes = {
  SET_PROJECT_ID: 'SET_PROJECT_ID',
  SET_MULTI_BLOCK: 'SET_MULTI_BLOCK',
  SET_TITLE: 'SET_TITLE',
  UPDATE_TITLE: 'UPDATE_TITLE',
  SET_LIST_VOICE: 'SET_LIST_VOICE',
  SET_CREATED_AT: 'SET_CREATED_AT',
  SET_PRODUCT: 'SET_PRODUCT',
  SET_IS_PLAYING: 'SET_IS_PLAYING',
  SET_CURRENT_BLOCK_ID: 'SET_CURRENT_BLOCK_ID',
  SET_VOICE_DEFAULT: 'SET_VOICE_DEFAULT',
  SET_AUDIO_LINK: 'SET_AUDIO_LINK',
  SET_IS_DRAFT: 'SET_IS_DRAFT',
  SET_IS_MULTI_BLOCK_MODE: 'SET_IS_MULTI_BLOCK_MODE',
  ADD_BLOCK: 'ADD_BLOCK',
  UPDATE_BLOCK: 'UPDATE_BLOCK',
  UPDATE_EXTRACTION_BLOCKS: 'UPDATE_EXTRACTION_BLOCKS',
  UPDATE_BLOCK_SYNTHESIS_INFO: 'UPDATE_BLOCK_SYNTHESIS_INFO',
  UPDATE_MULTI_BLOCK_SYNTHESIS_INFO: 'UPDATE_MULTI_BLOCK_SYNTHESIS_INFO',
  UPDATE_BLOCK_ELEMENTS: 'UPDATE_BLOCK_ELEMENTS',
  UPDATE_ORDER_BLOCK: 'UPDATE_ORDER_BLOCK',
  DELETE_BLOCK: 'DELETE_BLOCK',
  UPDATE_DURATION: 'UPDATE_DURATION',
  UPDATE_CURRENT_TIME: 'UPDATE_CURRENT_TIME',
  SET_IS_DOWNLOADING: 'SET_IS_DOWNLOADING',
  UPDATE_BLOCKS_WITH_PRONUNCIATION_CHANGE:
    'UPDATE_BLOCKS_WITH_PRONUNCIATION_CHANGE',
  UPDATE_ORIGINAL_BLOCKS: 'UPDATE_ORIGINAL_BLOCKS',
  SET_IS_PROJECT_SYNTHESIZING: 'SET_IS_PROJECT_SYNTHESIZING',
  SET_IS_GENERATING_NARRATION: 'SET_IS_GENERATING_NARRATION',
  UPDATE_CREDITS_BLOCKS: 'UPDATE_CREDITS_BLOCKS',
  DELETE_CREDITS_BLOCKS: 'DELETE_CREDITS_BLOCKS',
  SET_ORIGINAL_TITLE: 'SET_ORIGINAL_TITLE',
  SET_IS_PLAYING_BLOCK: 'SET_IS_PLAYING_BLOCK',
  SET_CURRENT_PLAYING_BLOCK_ID: 'SET_CURRENT_PLAYING_BLOCK_ID',
  SET_AUDIO_TYPE: 'SET_AUDIO_TYPE',
  SET_OPEN_DIALOG_CHANGE_FORMAT: 'SET_OPEN_DIALOG_CHANGE_FORMAT',
  SAVE_PROJECT: 'SAVE_PROJECT',
  SET_ORIGINAL_AUDIO_TYPE: 'SET_ORIGINAL_AUDIO_TYPE',
  UPDATE_MULTI_BLOCK_SYNTHESIS_STATUS: 'UPDATE_MULTI_BLOCK_SYNTHESIS_STATUS',
  UPDATE_BLOCK_STATUS: 'UPDATE_BLOCK_STATUS',
  UPDATE_BLOCKS_STATUS: 'UPDATE_BLOCKS_STATUS',
  SET_MULTI_BLOCK_STATUS: 'SET_MULTI_BLOCK_STATUS',
  SET_FILTER_STATUS: 'SET_FILTER_STATUS',
  SET_START_FILTER_BLOCK: 'SET_START_FILTER_BLOCK',
  SELECT_BLOCKS: 'SELECT_BLOCKS',
  UNSELECT_BLOCKS: 'UNSELECT_BLOCKS',
  UNSELECT_ALL_BLOCKS: 'UNSELECT_ALL_BLOCKS',
  DELETE_BLOCKS: 'DELETE_BLOCKS',
  SET_FILTER_VOICE_CODE: 'SET_FILTER_VOICE_CODE',
  SET_FILTER_SPEAKER_ID: 'SET_FILTER_SPEAKER_ID',
  SET_SPEAKERS: 'SET_SPEAKERS',
  UPDATE_SPEAKER: 'UPDATE_SPEAKER',
  ADD_SPEAKER: 'ADD_SPEAKER',
  DELETE_SPEAKER: 'DELETE_SPEAKER',
  SET_AUDIO_LINK_SRT: 'SET_AUDIO_LINK_SRT',
  SET_AUDIO_SRT_EXPIRED_AT: 'SET_AUDIO_SRT_EXPIRED_AT',
  SET_STATUS: 'SET_STATUS',
  DELETE_ALL_BLOCKS_CREDITS: 'DELETE_ALL_BLOCKS_CREDITS',
  UPDATE_ALL_BLOCKS_CREDITS: 'UPDATE_ALL_BLOCKS_CREDITS',
  SET_DUBBING_REQUEST_ID: 'SET_DUBBING_REQUEST_ID',
  SET_IS_PROJECT_CONVERTING_DRAFT: 'SET_IS_PROJECT_CONVERTING_DRAFT',
  UPDATE_MULTIPLE_BLOCKS: 'UPDATE_MULTIPLE_BLOCKS',
  SET_IS_PRE_PROCESSING_SYNTHESIS: 'SET_IS_PRE_PROCESSING_SYNTHESIS',
  SET_TRANSLATION: 'SET_TRANSLATION',
  SET_SYNTHESIS_PARAMS: 'SET_SYNTHESIS_PARAMS',
  SET_IS_TRANSLATING: 'SET_IS_TRANSLATING',
  SET_TRANSLATION_PENDING_SYNTHESIS: 'SET_TRANSLATION_PENDING_SYNTHESIS',
  TOGGLE_SHOW_ORIGINAL_TEXT: 'TOGGLE_SHOW_ORIGINAL_TEXT',
  CLEAR_TRANSLATION: 'CLEAR_TRANSLATION',
  SET_EXPORTS: 'SET_EXPORTS',
  SET_EXPORT_BY_TYPE: 'SET_EXPORT_BY_TYPE',
  SET_EXPORT_RECORDS_PAGE: 'SET_EXPORT_RECORDS_PAGE',
  SET_EXPORT_PROGRESS: 'SET_EXPORT_PROGRESS',
  SET_EXPORT_DOWNLOADING: 'SET_EXPORT_DOWNLOADING',
  SET_IS_LOADING_PROJECT_DETAIL: 'SET_IS_LOADING_PROJECT_DETAIL',
  SET_SOURCE: 'SET_SOURCE',
  SET_IS_BUFFERING: 'SET_IS_BUFFERING',
  SET_VIDEO_SETTINGS: 'SET_VIDEO_SETTINGS',
  SET_TRACK_VOLUME: 'SET_TRACK_VOLUME',
  SET_TRACK_VOLUMES: 'SET_TRACK_VOLUMES',
  SET_MUSIC_CLIPS: 'SET_MUSIC_CLIPS',
  ADD_MUSIC_CLIP: 'ADD_MUSIC_CLIP',
  DUPLICATE_MUSIC_CLIP: 'DUPLICATE_MUSIC_CLIP',
  UPDATE_MUSIC_CLIP: 'UPDATE_MUSIC_CLIP',
  DELETE_MUSIC_CLIP: 'DELETE_MUSIC_CLIP',
  UPDATE_VIDEO_SETTINGS: 'UPDATE_VIDEO_SETTINGS',
  APPLY_CAPTION_STYLE: 'APPLY_CAPTION_STYLE',
  UPDATE_CAPTION_STYLE: 'UPDATE_CAPTION_STYLE',
  SET_PROJECT_CAPTION_TEMPLATE_ID: 'SET_PROJECT_CAPTION_TEMPLATE_ID',
  SET_ORIGINAL_VIDEO_SETTINGS: 'SET_ORIGINAL_VIDEO_SETTINGS',
  SET_AUTO_SAVE_STATUS: 'SET_AUTO_SAVE_STATUS',
  SET_AUTO_SAVE_ENABLED: 'SET_AUTO_SAVE_ENABLED',
  SET_AUTO_SAVE_VIDEO_CONFIG: 'SET_AUTO_SAVE_VIDEO_CONFIG',
  PATCH_AUTO_SAVE_BASELINE: 'PATCH_AUTO_SAVE_BASELINE',
  AUTO_SAVE_TRIGGER: 'AUTO_SAVE_TRIGGER',
  SET_STREAMING_BLOCKS: 'SET_STREAMING_BLOCKS',
};

const setProjectId = (projectId) => ({
  type: actionTypes.SET_PROJECT_ID,
  payload: projectId,
});

const setMultiBlock = (multiBlock) => ({
  type: actionTypes.SET_MULTI_BLOCK,
  payload: multiBlock,
});

const setTitle = (title) => ({
  type: actionTypes.SET_TITLE,
  payload: title,
});

const updateTitle = (title) => ({
  type: actionTypes.UPDATE_TITLE,
  payload: title,
});

const setListVoice = (listVoice) => ({
  type: actionTypes.SET_LIST_VOICE,
  payload: listVoice,
});

const setCreatedAt = (createdAt) => ({
  type: actionTypes.SET_CREATED_AT,
  payload: createdAt,
});

const setProduct = (product) => ({
  type: actionTypes.SET_PRODUCT,
  payload: product,
});

const setIsPlaying = (isPlaying) => ({
  type: actionTypes.SET_IS_PLAYING,
  payload: isPlaying,
});

const setCurrentBlockId = (currentBlockId) => ({
  type: actionTypes.SET_CURRENT_BLOCK_ID,
  payload: currentBlockId,
});

const setVoiceDefault = (voiceDefault) => ({
  type: actionTypes.SET_VOICE_DEFAULT,
  payload: voiceDefault,
});

const setAudioLink = (audioLink) => ({
  type: actionTypes.SET_AUDIO_LINK,
  payload: audioLink,
});

const setIsDraft = (isDraft) => ({
  type: actionTypes.SET_IS_DRAFT,
  payload: isDraft,
});

const setIsMultiBlockMode = (isMultiBlockMode) => ({
  type: actionTypes.SET_IS_MULTI_BLOCK_MODE,
  payload: isMultiBlockMode,
});

const addBlock = (blockId, newBlocks, options = {}) => {
  const action = {
    type: actionTypes.ADD_BLOCK,
    // before: insert ahead of blockId, not after (the leading-gap case).
    payload: { blockId, newBlocks, before: options.before },
  };
  if (options.history) action.meta = { history: options.history };
  return action;
};

const updateBlock = (blockId, block, options = {}) => {
  const action = {
    type: actionTypes.UPDATE_BLOCK,
    payload: { blockId, block },
  };
  const meta = {};
  if (options.history) meta.history = options.history;
  // Non-content updates already handled elsewhere (e.g. the `rewrite` draft
  // field) set skipAutoSave so they don't flip the save status to "Saving".
  if (options.skipAutoSave) meta.skipAutoSave = true;
  if (Object.keys(meta).length > 0) action.meta = meta;
  return action;
};

const updateExtractionBlocks = (blocks, { syncOriginals = true } = {}) => ({
  type: actionTypes.UPDATE_EXTRACTION_BLOCKS,
  payload: { blocks, syncOriginals },
});

// Replace streaming blocks during transcribe-chunk polling, leaving originalBlocks intact.
const setStreamingBlocks = (blocks, blockIds) => ({
  type: actionTypes.SET_STREAMING_BLOCKS,
  payload: { blocks, blockIds },
});

const updateBlockSynthesisInfo = (blockId, synthesisInfo) => ({
  type: actionTypes.UPDATE_BLOCK_SYNTHESIS_INFO,
  payload: { blockId, synthesisInfo },
});
const updateMultiBlockSynthesisInfo = (blockIds, synthesisInfos) => ({
  type: actionTypes.UPDATE_MULTI_BLOCK_SYNTHESIS_INFO,
  payload: { blockIds, synthesisInfos },
});

const updateBlockElements = (blockId, elements) => ({
  type: actionTypes.UPDATE_BLOCK_ELEMENTS,
  payload: { blockId, elements },
});

const updateOrderBlock = (blockIds) => ({
  type: actionTypes.UPDATE_ORDER_BLOCK,
  payload: blockIds,
});

const deleteBlock = (blockId, options = {}) => {
  const action = {
    type: actionTypes.DELETE_BLOCK,
    payload: blockId,
  };
  if (options.history) action.meta = { history: options.history };
  return action;
};

const updateDuration = (duration) => ({
  type: actionTypes.UPDATE_DURATION,
  payload: duration,
});

const updateCurrentTime = (currentTime) => ({
  type: actionTypes.UPDATE_CURRENT_TIME,
  payload: currentTime,
});

const setIsDownloading = (isDownloading) => ({
  type: actionTypes.SET_IS_DOWNLOADING,
  payload: isDownloading,
});

const setExports = (exports) => ({
  type: actionTypes.SET_EXPORTS,
  payload: exports,
});

const setExportByType = (exportType, exportData) => ({
  type: actionTypes.SET_EXPORT_BY_TYPE,
  payload: { exportType, exportData },
});

// One loaded page: no cursor starts the list over, a cursor extends it.
const setExportRecordsPage = ({ records, nextCursor, cursor }) => ({
  type: actionTypes.SET_EXPORT_RECORDS_PAGE,
  payload: { records, nextCursor, cursor },
});

// Progress answers for the records asked about in one poll tick.
const setExportProgress = (records) => ({
  type: actionTypes.SET_EXPORT_PROGRESS,
  payload: { records },
});

// Which stored files are being fetched right now. A download outlives the row
// that started it: the history tab is mounted only while it is open, so a row
// cannot be what remembers this.
const setExportDownloading = (id, isDownloading) => ({
  type: actionTypes.SET_EXPORT_DOWNLOADING,
  payload: { id, isDownloading },
});

const setIsLoadingProjectDetail = (isLoading) => ({
  type: actionTypes.SET_IS_LOADING_PROJECT_DETAIL,
  payload: isLoading,
});

const updateBlocksWithPronunciationChange = (pronunciationChange) => ({
  type: actionTypes.UPDATE_BLOCKS_WITH_PRONUNCIATION_CHANGE,
  pronunciationChange,
});

const updateOriginalBlocks = (blockId) => ({
  type: actionTypes.UPDATE_ORIGINAL_BLOCKS,
  payload: blockId,
});

const setIsProjectSynthesizing = (isProjectSynthesizing) => ({
  type: actionTypes.SET_IS_PROJECT_SYNTHESIZING,
  payload: isProjectSynthesizing,
});

const setIsGeneratingNarration = (isGeneratingNarration, blockIds = []) => ({
  type: actionTypes.SET_IS_GENERATING_NARRATION,
  payload: { isGeneratingNarration, blockIds },
});

const updateCreditsBlocks = (blockId, credits) => ({
  type: actionTypes.UPDATE_CREDITS_BLOCKS,
  payload: { blockId, credits },
});

const deleteCreditsBlocks = (blockId) => ({
  type: actionTypes.DELETE_CREDITS_BLOCKS,
  payload: { blockId },
});

const setOriginalTitle = (originalTitle) => ({
  type: actionTypes.SET_ORIGINAL_TITLE,
  payload: originalTitle,
});

const setIsPlayingBlock = (isPlayingBlock) => ({
  type: actionTypes.SET_IS_PLAYING_BLOCK,
  payload: isPlayingBlock,
});

const setCurrentPlayingBlockId = (currentPlayingBlockId) => ({
  type: actionTypes.SET_CURRENT_PLAYING_BLOCK_ID,
  payload: currentPlayingBlockId,
});

const setAudioType = (audioType, options = {}) => {
  const action = {
    type: actionTypes.SET_AUDIO_TYPE,
    payload: audioType,
  };
  // Programmatic dispatches (e.g. initial project load) flag themselves so the
  // auto-save watchers ignore them and don't run a spurious save pass.
  if (options.skipAutoSave) action.meta = { skipAutoSave: true };
  return action;
};

const setOpenDialogChangeFormat = (openDialogChangeFormat) => ({
  type: actionTypes.SET_OPEN_DIALOG_CHANGE_FORMAT,
  payload: openDialogChangeFormat,
});

const saveProject = () => ({
  type: actionTypes.SAVE_PROJECT,
});

const setOriginalAudioType = (originalAudioType) => ({
  type: actionTypes.SET_ORIGINAL_AUDIO_TYPE,
  payload: originalAudioType,
});

// This action is only concerned with the synthesis status of each block.
const updateMultiBlockSynthesisStatus = (blocks) => ({
  type: actionTypes.UPDATE_MULTI_BLOCK_SYNTHESIS_STATUS,
  payload: { blocks },
});

const updateBlockStatus = ({ blockId, blockStatus }) => ({
  type: actionTypes.UPDATE_BLOCK_STATUS,
  payload: { blockId, blockStatus },
});

const updateBlocksStatus = ({ blockIds, blockStatus }) => ({
  type: actionTypes.UPDATE_BLOCKS_STATUS,
  payload: { blockIds, blockStatus },
});

const setMultiBlockStatus = (blocks) => ({
  type: actionTypes.SET_MULTI_BLOCK_STATUS,
  payload: { blocks },
});

const setFilterStatus = (filterStatus, options = {}) => {
  const action = {
    type: actionTypes.SET_FILTER_STATUS,
    payload: { filterStatus },
  };
  if (options.history) action.meta = { history: options.history };
  return action;
};

const setStartFilterBlock = (startFilterBlock) => ({
  type: actionTypes.SET_START_FILTER_BLOCK,
  payload: { startFilterBlock },
});

const selectBlocks = (blockIds) => ({
  type: actionTypes.SELECT_BLOCKS,
  payload: { blockIds },
});

const unselectBlocks = (blockIds) => ({
  type: actionTypes.UNSELECT_BLOCKS,
  payload: { blockIds },
});

const unselectAllBlocks = () => ({
  type: actionTypes.UNSELECT_ALL_BLOCKS,
});

const deleteBlocks = (blockIds, options = {}) => {
  const action = {
    type: actionTypes.DELETE_BLOCKS,
    payload: { blockIds },
  };
  if (options.history) action.meta = { history: options.history };
  return action;
};

const setFilterVoiceCode = (filterVoiceCode) => ({
  type: actionTypes.SET_FILTER_VOICE_CODE,
  payload: { filterVoiceCode },
});

const setFilterSpeakerId = (filterSpeakerId, options = {}) => {
  const action = {
    type: actionTypes.SET_FILTER_SPEAKER_ID,
    payload: { filterSpeakerId },
  };
  if (options.history) action.meta = { history: options.history };
  return action;
};

const setSpeakers = (speakers) => ({
  type: actionTypes.SET_SPEAKERS,
  payload: speakers,
});

const updateSpeaker = (speakerId, speaker) => ({
  type: actionTypes.UPDATE_SPEAKER,
  payload: { speakerId, speaker },
});

const addSpeaker = (speaker) => ({
  type: actionTypes.ADD_SPEAKER,
  payload: speaker,
});

const deleteSpeaker = (speakerId) => ({
  type: actionTypes.DELETE_SPEAKER,
  payload: speakerId,
});

const setAudioLinkSrt = (audioLinkSrt) => ({
  type: actionTypes.SET_AUDIO_LINK_SRT,
  payload: audioLinkSrt,
});

const setAudioSrtExpiredAt = (audioSrtExpiredAt) => ({
  type: actionTypes.SET_AUDIO_SRT_EXPIRED_AT,
  payload: audioSrtExpiredAt,
});

const setStatus = (status) => ({
  type: actionTypes.SET_STATUS,
  payload: status,
});

const setSource = (source) => ({
  type: actionTypes.SET_SOURCE,
  payload: source,
});

const setIsBuffering = (isBuffering) => ({
  type: actionTypes.SET_IS_BUFFERING,
  payload: isBuffering,
});

const setVideoSettings = (videoSettings) => ({
  type: actionTypes.SET_VIDEO_SETTINGS,
  payload: videoSettings,
});

// Replace the whole list — used to restore saved clips when a project loads.
const setMusicClips = (clips) => ({
  type: actionTypes.SET_MUSIC_CLIPS,
  payload: clips,
});

const addMusicClip = (clip, options = {}) => {
  const action = { type: actionTypes.ADD_MUSIC_CLIP, payload: clip };
  if (options.history) action.meta = { history: options.history };
  return action;
};

// Insert `clip` right after the one with `afterId`.
const duplicateMusicClip = (afterId, clip, options = {}) => {
  const action = {
    type: actionTypes.DUPLICATE_MUSIC_CLIP,
    payload: { afterId, clip },
  };
  if (options.history) action.meta = { history: options.history };
  return action;
};

const updateMusicClip = (id, changes, options = {}) => {
  const action = {
    type: actionTypes.UPDATE_MUSIC_CLIP,
    payload: { id, changes },
  };
  if (options.history) action.meta = { history: options.history };
  return action;
};

const deleteMusicClip = (id, options = {}) => {
  const action = { type: actionTypes.DELETE_MUSIC_CLIP, payload: id };
  if (options.history) action.meta = { history: options.history };
  return action;
};

const updateVideoSettings = (videoSettings) => ({
  type: actionTypes.UPDATE_VIDEO_SETTINGS,
  payload: videoSettings,
});

const applyCaptionStyle = (styleId, config, { history } = {}) => ({
  type: actionTypes.APPLY_CAPTION_STYLE,
  payload: { styleId, config },
  ...(history ? { meta: { history } } : {}),
});

// Sau khi auto-save tạo style riêng: trỏ panel sang id thật.
const setProjectCaptionTemplateId = (captionTemplateId) => ({
  type: actionTypes.SET_PROJECT_CAPTION_TEMPLATE_ID,
  payload: captionTemplateId,
});

// Patch một tầng; reducer merge sâu vào đúng nhóm của config.
const updateCaptionStyle = (group, patch, { history } = {}) => ({
  type: actionTypes.UPDATE_CAPTION_STYLE,
  payload: { group, patch },
  ...(history ? { meta: { history } } : {}),
});

const setOriginalVideoSettings = (videoSettings) => ({
  type: actionTypes.SET_ORIGINAL_VIDEO_SETTINGS,
  payload: videoSettings,
});

const setAutoSaveStatus = (status) => ({
  type: actionTypes.SET_AUTO_SAVE_STATUS,
  payload: status,
});

const setAutoSaveEnabled = (enabled) => ({
  type: actionTypes.SET_AUTO_SAVE_ENABLED,
  payload: enabled,
});

// Feature-flag context the auto-save engine needs to build the Dubbing
// videoSettings payload (which fields to include) — set by the Dubbing screen.
const setAutoSaveVideoConfig = (config) => ({
  type: actionTypes.SET_AUTO_SAVE_VIDEO_CONFIG,
  payload: config,
});

// Level of one mixer track (`voiceover` | `media` | `music`), 0..1. These are
// project state, not playback state: auto-save persists them and the export mixes
// them in. `skipAutoSave` lets the load restore them without scheduling a save.
const setTrackVolume = (
  track,
  value,
  { skipAutoSave = false, history } = {},
) => ({
  type: actionTypes.SET_TRACK_VOLUME,
  payload: { track, value },
  meta: { skipAutoSave, ...(history ? { history } : {}) },
});

// Restore every level at once (project load).
const setTrackVolumes = (volumes) => ({
  type: actionTypes.SET_TRACK_VOLUMES,
  payload: volumes,
  meta: { skipAutoSave: true },
});

const patchAutoSaveBaseline = ({ blockIds, blocks, removedIds, meta }) => ({
  type: actionTypes.PATCH_AUTO_SAVE_BASELINE,
  payload: { blockIds, blocks, removedIds, meta },
});

const autoSaveTrigger = () => ({ type: actionTypes.AUTO_SAVE_TRIGGER });

const deleteAllBlocksCredits = () => ({
  type: actionTypes.DELETE_ALL_BLOCKS_CREDITS,
});

const updateAllBlocksCredits = (blockCredits) => ({
  type: actionTypes.UPDATE_ALL_BLOCKS_CREDITS,
  payload: blockCredits,
});

const setDubbingRequestId = (dubbingRequestId) => ({
  type: actionTypes.SET_DUBBING_REQUEST_ID,
  payload: dubbingRequestId,
});

const setIsProjectConvertingDraft = (isProjectConvertingDraft) => ({
  type: actionTypes.SET_IS_PROJECT_CONVERTING_DRAFT,
  payload: isProjectConvertingDraft,
});

const updateMultipleBlocks = (blockUpdates, options = {}) => {
  const action = {
    type: actionTypes.UPDATE_MULTIPLE_BLOCKS,
    payload: { blockUpdates },
  };
  const meta = {};
  if (options.history) meta.history = options.history;
  // Programmatic merges already persisted elsewhere (e.g. translate/rewrite
  // results from the Backend) set skipAutoSave so they don't trigger a redundant
  // auto-save pass.
  if (options.skipAutoSave) meta.skipAutoSave = true;
  if (Object.keys(meta).length > 0) action.meta = meta;
  return action;
};

const setIsPreProcessingSynthesis = (isPreProcessingSynthesis) => ({
  type: actionTypes.SET_IS_PRE_PROCESSING_SYNTHESIS,
  payload: isPreProcessingSynthesis,
});

const setTranslation = (translation) => ({
  type: actionTypes.SET_TRANSLATION,
  payload: translation,
});

const setSynthesisParams = (synthesisParams) => ({
  type: actionTypes.SET_SYNTHESIS_PARAMS,
  payload: synthesisParams,
});

const setIsTranslating = (isTranslating) => ({
  type: actionTypes.SET_IS_TRANSLATING,
  payload: isTranslating,
});

const setTranslationPendingSynthesis = (isPending) => ({
  type: actionTypes.SET_TRANSLATION_PENDING_SYNTHESIS,
  payload: isPending,
});

const toggleShowOriginalText = () => ({
  type: actionTypes.TOGGLE_SHOW_ORIGINAL_TEXT,
});

const clearTranslation = () => ({
  type: actionTypes.CLEAR_TRANSLATION,
});

export {
  setProjectId,
  setMultiBlock,
  setTitle,
  updateTitle,
  setListVoice,
  setCreatedAt,
  setProduct,
  setIsPlaying,
  setCurrentBlockId,
  setVoiceDefault,
  setAudioLink,
  setIsDraft,
  setIsMultiBlockMode,
  addBlock,
  updateBlock,
  updateExtractionBlocks,
  updateMultipleBlocks,
  updateBlockSynthesisInfo,
  updateBlockElements,
  updateOrderBlock,
  deleteBlock,
  updateDuration,
  updateCurrentTime,
  updateMultiBlockSynthesisInfo,
  setIsDownloading,
  setExports,
  setExportByType,
  setExportRecordsPage,
  setExportProgress,
  setExportDownloading,
  updateBlocksWithPronunciationChange,
  updateOriginalBlocks,
  setIsProjectSynthesizing,
  setIsGeneratingNarration,
  updateCreditsBlocks,
  deleteCreditsBlocks,
  setOriginalTitle,
  setIsPlayingBlock,
  setCurrentPlayingBlockId,
  setAudioType,
  setOpenDialogChangeFormat,
  saveProject,
  setOriginalAudioType,
  updateMultiBlockSynthesisStatus,
  updateBlockStatus,
  updateBlocksStatus,
  setMultiBlockStatus,
  setFilterStatus,
  setStartFilterBlock,
  selectBlocks,
  unselectBlocks,
  unselectAllBlocks,
  deleteBlocks,
  setFilterVoiceCode,
  setFilterSpeakerId,
  setSpeakers,
  updateSpeaker,
  addSpeaker,
  deleteSpeaker,
  setAudioLinkSrt,
  setAudioSrtExpiredAt,
  setStatus,
  deleteAllBlocksCredits,
  updateAllBlocksCredits,
  setDubbingRequestId,
  setIsProjectConvertingDraft,
  setIsPreProcessingSynthesis,
  setTranslation,
  setSynthesisParams,
  setIsTranslating,
  setTranslationPendingSynthesis,
  toggleShowOriginalText,
  clearTranslation,
  setIsLoadingProjectDetail,
  setSource,
  setIsBuffering,
  setVideoSettings,
  setMusicClips,
  addMusicClip,
  duplicateMusicClip,
  updateMusicClip,
  deleteMusicClip,
  updateVideoSettings,
  applyCaptionStyle,
  updateCaptionStyle,
  setProjectCaptionTemplateId,
  setOriginalVideoSettings,
  setAutoSaveStatus,
  setAutoSaveEnabled,
  setAutoSaveVideoConfig,
  patchAutoSaveBaseline,
  setTrackVolume,
  setTrackVolumes,
  autoSaveTrigger,
  setStreamingBlocks,
};
